import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { firebaseConnect, isLoaded, isEmpty } from 'react-redux-firebase';
import { connect } from 'react-redux';
import { AppView, ModalView, Notice, Input } from 'medua-components';

import CoursesCourseInformation from './information';
import CoursesCourseDescription from './description';

/* eslint-disable */
@firebaseConnect(
  ({ params }) =>
    [{ path: `courses/${params.slug}`, storeAs: 'course' }]
)
@connect(
  ({ firebase: { data: { course }} }) => ({
    course,
  })
)
@translate('degree')
export default class CoursesCourse extends Component {

  constructor(props) {
    super(props);

    this.state = {
      tabIndex: 1,

      value: props.course ? props.course.description : '<h1>Wählen Sie eine Überschrift</h1><p>Aktivieren Sie unten den Bearbeitungsmodus und beschreiben Sie ihren Kurs</p>',
      readOnly: true,

      menuIsOpen: false,
      modalDeleteIsOpen: false
    };

    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
    this.handleLock = this.handleLock.bind(this);
    this.handleDelete = this.handleDelete.bind(this);

    this.openMenu = this.openMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);

    this.openDeleteModal = this.openDeleteModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  handleOnChange(value) {
    this.setState({ value });
  }

  handleOnBlur(value) {
    this.setState({ value });
  }

  handleLock() {
    if (this.state.readOnly) {
      this.setState({ readOnly: false })
    } else {
      this.setState({ readOnly: true })
      if (this.state.value.localeCompare(this.props.course.description) != 0) {
        this.props.firebase.update(
          `courses/${this.props.params.slug}`, {
            description: this.state.value
        })
        // toast.success("Saved!")
      }
    }
  }

  handleDelete() {
    if (this.state.delete_validation == this.props.course.name) {
      this.props.firebase.remove(`course/${this.props.params.slug}`)
      this.closeModal()
      this.props.history.push('/courses')
    }
    this.setState({ error_delete: 'The delete validation is not correct.'})
  }

  openMenu() {
    this.setState({ menuIsOpen: true })
  }
  closeMenu() {
    this.setState({ menuIsOpen: false })
  }

  openDeleteModal() {
    this.setState({modalDeleteIsOpen: true });
  }
  closeModal() {
    this.setState({modalDeleteIsOpen: false});
  }

  renderClasses(classes) {
    return Object.keys(classes).map((c) => {
      return (<PanelListItemDuo
            key={ c }
            url={ '/courses/' + this.props.params.slug  + '/classes/' + c }
            title={ classes[c].classID }
            info={ classes[c].classID } />);
    });
  }

  render() {
    // let view;
    // if (!isLoaded(this.props.course)) {
    //   view = ( 'Loading' );
    // } else if (isEmpty(this.props.course)) {
    //   view = ( 'Not found' );
    // } else {
    //   view = (
    //     <div className="panel-view connect">
    //       <Tabs
    //         tabsBarClassName={
    //           "tabbar"
    //         }
    //         lineStyle={{
    //           backgroundColor: '#00aa96'
    //         }}
    //         banner={{
    //           children: () => (
    //             <section className="panel-view-header">
    //               <div className="view-header-center">
    //                 <h2>{ this.props.course.name }</h2>
    //                 <h3>{ this.props.course.degree ? this.props.module.degree : "Degree" }</h3>
    //               </div>
    //               <div className="view-header-right">
    //                 <Link onClick={this.openModal}><i className="icon icon-settings" /></Link>
    //               </div>
    //             </section>
    //           )
    //         }}
    //         tabs={[
    //           {
    //             children: () => (
    //               <div className={ this.state.readOnly ? 'editor editor-locked' : 'editor'}>
    //                 <Editor
    //                   readOnly={this.state.readOnly}
    //                   value={this.state.value}
    //                   onChange={this.handleOnChange}
    //                   onBlur={this.handleOnBlur}
    //                 />
    //                 <section className="panel-view-footer">
    //                   <div className="panel-view-button-container">
    //                     { this.state.readOnly ?
    //                       <Link onClick={this.handleLock} className="button turquoise">Edit</Link>
    //                       :
    //                       this.state.value.localeCompare(this.props.course.description) != 0 ?
    //                         <Link onClick={this.handleLock} className="button primary">Save</Link>
    //                         :
    //                         <Link onClick={this.handleLock} className="button">Back</Link>
    //                     }
    //                   </div>
    //                 </section>
    //               </div>
    //             ),
    //             displayName: 'Information'
    //           },
    //           {
    //             children: () => (
    //               <div>
    //                 <div className="panel-view-list">
    //                   <ul>
    //                     { this.renderClasses(this.props.course.classes) }
    //                   </ul>
    //                 </div>
    //                 <section className="panel-view-footer">
    //                   <div className="panel-view-button-container">
    //                     <Link className="button turquoise">Add</Link>
    //                   </div>
    //                 </section>
    //               </div>
    //             ),
    //             displayName: 'Classes'
    //           }
    //         ]}
    //       />
    //     </div>
    //   );
    // }
    const { user, course } = this.props

    return (
      <AppView
        loading={ !isLoaded(course) }
        empty={{
          state: isEmpty(course),
          title: this.props.t('courses:empty.title'),
          text: this.props.t('courses:empty.text')
        }}
        headerSize="medium"
        color="turquoise"
        title={ course && course.name }
        subtitle={ course && this.props.t(`degree:title.${course.degree.title}`) }
        headerActionRight={
          isLoaded(user) && isLoaded(course) && !isEmpty(course) && course.school.key == user.school.key ?
          [{
            type: 'menu',
            menu: [{ items: [{ text: this.props.t('actions:text.delete'), action: this.openDeleteModal }] }],
            icon: 'settings',
            open: this.openMenu,
            close: this.closeMenu,
            state: this.state.menuIsOpen
          }]
          : false
        }
        tabs={[
          {
            title: this.props.t('courses:tabs.information'),
            content: <CoursesCourseInformation
                        key={this.props.params.slug}
                        course={course}
                        id={this.props.params.slug} />
          },
          {
            title: this.props.t('courses:tabs.description'),
            content: <CoursesCourseDescription
                        key={this.props.params.slug}
                        course={course} />
          },
          {
            title: this.props.t('courses:tabs.classes'),
            content: <div>Coming soon</div>
          },
        ]}
        modals={[
          {
            key: 1,
            show: this.state.modalDeleteIsOpen,
            close: this.closeModal,
            content: <ModalView
                        title="Delete Course"
                        error={ this.state.error_delete }
                        buttons={[
                          { type: 'info', text: this.props.t('actions:text.close'), action: this.closeModal, outline: true },
                          { type: 'alert', text: this.props.t('actions:text.delete'), action: this.handleDelete },
                        ]}>
                        <Notice
                          type="warning"
                          title="Warnung"
                          text="Wenn Sie diesen Kurs löschen, werden alle Ihre Studenten des Kurses vom Kurs entfernt und können nicht weiter auf den Kurs zugreifen. Falls es Unstimmigkeiten gibt oder der Kurs umziehen soll, stehen wir Ihnen gerne über unsere Support Möglichkeiten zur Verfügung." />
                        <p className="text">Um diesen Kurs zu löschen, geben Sie den Namen des Kurses ( <strong>{ course && course.name }</strong> ) in das folgende Feld ein.</p>
                        <Input
                          meta="Kursname"
                          value={ this.state.delete_validation }
                          onChange={ (e) => this.setState({ delete_validation: e.target.value })} />
                      </ModalView>
          }
        ]} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/courses/course/index.jsx